export const ghprojects = [
    {
        id: 1,
        title: "DogHub",
        subtitle: "Express, Handlebars, MySQL, and MVC model",
        description:
        "The app allows users to create a profile for their dog, including information about their breed and age. Using this information, the users will be able to swipe and match with other dogs based on their description. Users are able to message their matches to set up playdates.",
        image: "../images/doghub.png",
        github:'https://github.com/davidpascual2/Project-2',
        link: "https://ancient-scrubland-48723.herokuapp.com/",
        demo:'../demo/doghub.gif'
    },
    {
        id: 2,
        title: "Pefi",
        subtitle: "MongoDB, Express, React, Node.Js, GraphQL",
        description:
        "Pefi is a comprehensive personal finance management app that empowers users to plan, track, and achieve their financial goals. With intuitive interfaces, interactive charts, and powerful tools, Pefi helps users make informed decisions about their money.",
        image: "../images/pefi-dash.png",
        github:'https://github.com/c1008h/Pefi',
        link: "https://pefi.netlify.app",
        demo: '../demo/PeFi.gif'
    },
    {
        id: 3,
        title: "Food Genie",
        subtitle: "MongoDB, Express, React, Node.Js, GraphQL",
        description:
        "Introducing the Food Genie, the perfect solution for indecisive foodies! Save all your favorite foods and restaurants in one place, and let the Genie take care of the rest. With a simple tap, the Genie randomly selects an item from your saved list, saving you time and reducing the stress of deciding where to eat. No more endless scrolling or debating with friends, let the Food Genie help you discover new and exciting dining experiences.",
        image: "../images/foodgenie.png",
        github:'https://github.com/c1008h/FoodGenie',
        link: "https://thefoodgenie.netlify.app",
        demo:'../demo/FoodGenie.gif'
    },
    {
        id: 4,
        title: "E-Commerce",
        subtitle: "Node.Js, MySQL & Express",
        description:
        "This is the server-side component of an online store that utilizes MySQL as the database management system. It handles all the behind-the-scenes functionality of the store, such as managing customer information, processing orders, and updating inventory levels. The app provides a robust and reliable platform for managing the e-commerce operations, allowing store owners to focus on growing their business. The app's use of MySQL ensures that all data is securely stored and can be easily accessed and manipulated to support the smooth functioning of the e-commerce store.",
        image: "../images/ecombackend.png",
        github:'https://github.com/c1008h/E-Commerce-Backend',
        demo:'../demo/ecombackend.gif'
    },
    {
        id: 5,
        title: "Snake Game",
        subtitle: "HTML, CSS, and JavaScript",
        description:
        "A snake game is a classic arcade-style game where the player controls a snake that moves across the screen, collecting food and growing in length. The goal of the game is to avoid collision with the walls or the snake's own body, and reach the highest score possible. The snake's movement is controlled by the player using arrow keys. The game becomes more challenging as the snake grows longer, and the player must navigate through increasingly tighter spaces. The game often features various power-ups that can increase the snake's speed. The game ends when the snake crashes into a wall or its own body.",
        image: "../images/snakegame.png",
        github:'https://github.com/c1008h/Snake-Game',
        link: "https://c1008h.github.io/Snake-Game/",
        demo: '../demo/SnakeGame.gif'
    },
    // {
    //     id: 6,
    //     title: "Employee Profile",
    //     subtitle: "JavaScript, Node.js & Express",
    //     description:
    //     "An application to keep track of employees within a company by answering questions in the terminal and render it onto the web",
    //     image: "./images/teamprofilegenerator.png",
    //     github:'https://github.com/c1008h/team-profile-generator',
    // },
    // {
    //     id: 7,
    //     title: "Day Planner",
    //     subtitle: "JavaScript, jQuery, CSS, Third Party APIs & Bootstrap",
    //     description:
    //     "This app utilizes third-party APIs to allow users to input their schedule between the hours of 9am and 5pm. The background color of the schedule will change dynamically to indicate whether a specific time has passed, is currently happening, or is yet to come. This feature allows users to easily keep track of their schedule and stay on top of their tasks throughout the day.",
    //     image: "../images/workday.png",
    //     github:'https://github.com/c1008h/Day-Planner',
    //     link: "https://c1008h.github.io/Day-Planner/",
    //     demo: '../demo/workday.gif'
    // },
    // {
    //     id: 8,
    //     title: "README.md",
    //     subtitle: "Node.Js & NPM",
    //     description:
    //     "This app is a command-line tool built using Node.js that helps users create a well-formatted README file for their projects. The app prompts users with a series of questions in the terminal, such as project name, description, and installation instructions. As the users answer the questions, the app generates a corresponding markdown for the README file, saving users time and effort in manually formatting the document. The app makes it easy for developers to quickly and efficiently create professional-looking README files for their projects.",
    //     image: "../images/readme-generator.png",
    //     github:'https://github.com/c1008h/Professional-README-Generator',
    //     link: "",
    //     demo: '../demo/readme.gif'
    // }
];
  
